import React, { useState } from "react";

const Contact = () => {
  const [message, setMessage] = useState("");

  //javascript para abrir whatsapp
  const openWhatsApp = () => {
    const encodedMessage = encodeURIComponent(message);
    const url = `https://api.whatsapp.com/send?phone=5511920929438&text=${encodedMessage}`;
    window.open(url, "_blank");
  }

  return (
    <section id='contact' className="contact-page-wrapper">
      <header>
        <h1 className="primary-heading">Quer conversar conosco?</h1>
        <h2 className="primary-heading">Chama a gente no whatsapp</h2>
      </header>
      <div className="contact-form-container">
        <label htmlFor="whatsapp-message" className="sr-only">Digite sua mensagem para o WhatsApp</label>
        <input 
          id="whatsapp-message"
          type="text" 
          placeholder="Digite sua mensagem aqui" 
          value={message} 
          onChange={(e) => setMessage(e.target.value)}
          aria-describedby="whatsapp-help"
        />
        <p id="whatsapp-help" className="sr-only">
          Digite sua mensagem e clique no botão para abrir o WhatsApp
        </p>
        <button 
          className="secondary-button" 
          onClick={() => openWhatsApp()}
          aria-label="Abrir WhatsApp para enviar mensagem"
        >
          Abrir WhatsApp
        </button>
      </div>
      <nav aria-label="Links relacionados">
        <ul style={{ listStyle: 'none', padding: 0 }}>
          <li><a href="https://loja.verdemusgonatural.com.br" target="_blank" rel="noopener noreferrer">Visite nossa loja online</a></li>
          <li><a href="https://track.verdemusgonatural.com.br" target="_blank" rel="noopener noreferrer">Rastreie nossa produção</a></li>
          <li><a href="https://blog.verdemusgonatural.com.br" target="_blank" rel="noopener noreferrer">Veja nossas receitas</a></li>
        </ul>
      </nav>
    </section>
  );
};

export default Contact;
